export const interviewKitConstants = {
  // create Interview Kit
  CREATE_INTERVIEW_KIT_ACTION_REQUEST: "CREATE_INTERVIEW_KIT_ACTION_REQUEST",
  CREATE_INTERVIEW_KIT_ACTION_SUCCESS: "CREATE_INTERVIEW_KIT_ACTION_SUCCESS",
  CREATE_INTERVIEW_KIT_ACTION_FAILURE: "CREATE_INTERVIEW_KIT_ACTION_FAILURE",

  // update Interview Kit
  UPDATE_INTERVIEW_KIT_ACTION_REQUEST: "UPDATE_INTERVIEW_KIT_ACTION_REQUEST",
  UPDATE_INTERVIEW_KIT_ACTION_SUCCESS: "UPDATE_INTERVIEW_KIT_ACTION_SUCCESS",
  UPDATE_INTERVIEW_KIT_ACTION_FAILURE: "UPDATE_INTERVIEW_KIT_ACTION_FAILURE",

  //Interview Kit
  GET_INTERVIEW_KIT_BY_ID_ACTION_REQUEST:
    "GET_INTERVIEW_KIT_BY_ID_ACTION_REQUEST",
  GET_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS:
    "GET_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS",
  GET_INTERVIEW_KIT_BY_ID_ACTION_FAILURE:
    "GET_INTERVIEW_KIT_BY_ID_ACTION_FAILURE",

  // MENTOR ALL INTERVIEW
  GET_ALL_INTERVIEW_KIT_ACTION_REQUEST: "GET_ALL_INTERVIEW_KIT_ACTION_REQUEST",
  GET_ALL_INTERVIEW_KIT_ACTION_SUCCESS: "GET_ALL_INTERVIEW_KIT_ACTION_SUCCESS",
  GET_ALL_INTERVIEW_KIT_ACTION_FAILURE: "GET_ALL_INTERVIEW_KIT_ACTION_FAILURE",

  // MENTOR ALL Published INTERVIEW
  GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_REQUEST:
    "GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_REQUEST",
  GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_SUCCESS:
    "GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_SUCCESS",
  GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_FAILURE:
    "GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_FAILURE",

  // DELETE INTERVIEW
  DELETE_INTERVIEW_KIT_BY_ID_ACTION_REQUEST:
    "DELETE_INTERVIEW_KIT_BY_ID_ACTION_REQUEST",
  DELETE_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS:
    "DELETE_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS",
  DELETE_INTERVIEW_KIT_BY_ID_ACTION_FAILURE:
    "DELETE_INTERVIEW_KIT_BY_ID_ACTION_FAILURE",

  // assign interview kit
  ASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST:
    "ASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST",
  ASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
    "ASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS",
  ASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE:
    "ASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE",

  // unassign interview kit
  UNASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST:
    "UNASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST",
  UNASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
    "UNASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS",
  UNASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE:
    "UNASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE",

  // get assigned interview kit
  GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_REQUEST:
    "GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_REQUEST",
  GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_SUCCESS:
    "GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_SUCCESS",
  GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_FAILURE:
    "GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_FAILURE",

  //set interview title
  SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_REQUEST:
    "SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_REQUEST",
  SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS:
    "SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS",
  SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_FAILURE:
    "SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_FAILURE",

  //delete interview kit topic
  DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST:
    "DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST",
  DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS:
    "DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS",
  DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE:
    "DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE",

  //update interview kit topic
  UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST:
    "UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST",
  UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS:
    "UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS",
  UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE:
    "UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE",

  //add interview kit topic question
  ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST:
    "ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST",
  ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS:
    "ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS",
  ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE:
    "ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE",

  //delete interview kit topic question
  DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST:
    "DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST",
  DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS:
    "DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS",
  DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE:
    "DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE",

  //update interview kit topic question
  UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST:
    "UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST",
  UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS:
    "UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS",
  UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE:
    "UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE",

  //update interview kit topic question
  GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_REQUEST:
    "GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_REQUEST",
  GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS:
    "GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS",
  GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_FAILURE:
    "GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_FAILURE",

  //update interview kit topic question
  ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
    "ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST",
  ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
    "ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS",
  ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
    "ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE",

  //update interview kit topic question
  UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
    "UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST",
  UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
    "UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS",
  UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
    "UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE",

  //update interview kit topic question
  GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST:
    "GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST",
  GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS:
    "GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS",
  GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE:
    "GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE",

  //Add Remark
  ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST:
    "ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST",
  ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS:
    "ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS",
  ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE:
    "ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE",

  //GET ALL Remark List
  GET_REMARK_LIST_DATA_ACTION_REQUEST: "GET_REMARK_LIST_DATA_ACTION_REQUEST",
  GET_REMARK_LIST_DATA_ACTION_SUCCESS: "GET_REMARK_LIST_DATA_ACTION_SUCCESS",
  GET_REMARK_LIST_DATA_ACTION_FAILURE: "GET_REMARK_LIST_DATA_ACTION_FAILURE",

  //Update Remark
  UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST: "UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST",
  UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS: "UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS",
  UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE: "UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE",

  // update Interview question
  UPDATE_INTERVIEW_QUESTION_ACTION_REQUEST: "UPDATE_INTERVIEW_QUESTION_ACTION_REQUEST",
  UPDATE_INTERVIEW_QUESTION_ACTION_SUCCESS: "UPDATE_INTERVIEW_QUESTION_ACTION_SUCCESS",
  UPDATE_INTERVIEW_QUESTION_ACTION_FAILURE: "UPDATE_INTERVIEW_QUESTION_ACTION_FAILURE",

};
